import React from 'react';
import styled from 'styled-components';

import { H4 } from '../styledComponents1'
import { DeviceImage } from '../imageComponents'

const Device = styled.div`
    margin-bottom: 44px;

    text-align: center;
`;
const Image = styled.div`
    margin: 0 auto 8px;
`;
const Name = styled(H4)`
    font-size: 14px;
`;

const DeviceItem = (props) => {
    
    return (
        <Device key={props.name}>
            <Image>
                <DeviceImage imgSrc={props.imgSrc} fluid="presentationWidth" />
            </Image>
            <Name>{props.name}</Name>
        </Device>
    );
};

export default DeviceItem;
